import Api, {editedSlug as provider} from '@cabinet/services'
export default {
  fetch(data) {
    return Api().get(`/finance/list/`, {
      params: data
    })
  } 
}